import type {ControlledTooltipProps} from '@github-ui/portal-tooltip/controlled'
import type React from 'react'

import {LABELS} from '../constants/labels'
import {TEST_IDS} from '../constants/test-ids'
import {CommentHeaderBadge} from './CommentHeaderBadge'

type Props = {
  viewerDidAuthor?: boolean
  subjectType?: string
  tooltipDirection?: ControlledTooltipProps['direction']
}

export const CommentSubjectAuthor: React.FC<Props> = ({viewerDidAuthor, subjectType, tooltipDirection}: Props) => {
  return (
    <CommentHeaderBadge
      viewerDidAuthor={viewerDidAuthor}
      ariaLabel={LABELS.commentSubjectAuthor(viewerDidAuthor ?? false, subjectType ?? 'comment')}
      label={LABELS.commentAuthor}
      testId={TEST_IDS.commentSubjectAuthor}
      tooltipDirection={tooltipDirection}
    />
  )
}
